export const ExlibrisTheme = {
  name: 'Exlibris Theme',
  themeId: 'exlibris',
  colors: {
    brand: {
      primary: {
        100: '#bf0d3e'
      },
      secondary: {
        100: '#cc3d65'
      },
      accent: {
        100: '#bf0d3e'
      },
      negative: {
        100: '#e00009'
      },
      alternative: {
        100: '#cc3d65'
      }
    }
  },
  backgrounds: {
    tile: '#bf0d3e'
  },
  fonts: {
    families: {
      text: 'MiloWeb-Text, MiloWeb, arial, sans-serif',
      condensed: 'MiloWeb-Text, MiloWeb, arial, sans-serif',
      notes: 'MiloWeb-Text, MiloWeb, arial, sans-serif',
      heading: 'MiloWeb-Bold, MiloWeb, arial, sans-serif',
      subHeading: 'MiloWeb-Bold, MiloWeb, arial, sans-serif',
      display: 'MiloWeb-Bold, MiloWeb, arial, sans-serif',
      articleText: 'MiloWeb-Text, MiloWeb, arial, sans-serif',
      articleHeading: 'MiloWeb-Text, MiloWeb, arial, sans-serif'
    },
    weights: {
      thin: 400,
      light: 400,
      bold: 700
    }
  }
};